

























































































































































































































































import moment from "moment";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import { Component, Vue, Watch } from "vue-property-decorator";
import QCalendar from "@/common/qCalendar.vue";
import { DATE_PICKER_FORMAT, DATE_TIME_FORMAT, DATETIME_FORMAT_PDF_FILE_NAME } from "@/common/constant";
import OrderHistoryParentRecord from "@/model/orderHistoryParentRecord";
import orderApi from "@/api/orderApi";
import _filter from "lodash/filter";
import _isObject from "lodash/isObject";
import _pickBy from "lodash/pickBy";
import _isEmpty from "lodash/isEmpty";
import store from "@/store";
import draggable from "vuedraggable";
import qNotify from "@/common/qNotify";

@Component({
  name: "AdminOrderHistory",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QCalendar,
    draggable,
  },
})
export default class AdminOrderHistory extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public orderHistoryParentRows: OrderHistoryParentRecord[] = [];
  public orderHistories = [];

  public headerAttribute = {
    orre_date: { id: "order_date", name: "注文日", class: "Char_8" },
    desire_dlvr_day: {
      id: "desire_dlvr_day",
      name: "希望出荷日",
      class: "Char_8",
    },
    ans_dlvr_day: { id: "ans_dlvr_day", name: "確定出荷日", class: "Char_8" },
    sals_day: {
      id: "sals_day",
      name: "納入日（売上日）",
      class: "Char_8 Long",
    },
    order_num: { id: "order_num", name: "注文番号", class: "Char_20" },
    customer_name: { id: "customer_name", name: "会社名", class: "Char_42" },
    customer_supervisor_name: {
      id: "customer_supervisor_name",
      name: "部署担当者名",
      class: "Char_42",
    },
    dlv_dst_name: { id: "dlv_dst_name", name: "納入先名", class: "Char_42" },
    dlv_dst_address: {
      id: "dlv_dst_address",
      name: "納入先住所",
      class: "Char_42 Wrap",
    },
    dlv_dst_tel_number: {
      id: "dlv_dst_tel_number",
      name: "納入先TEL",
      class: "Char_15",
    },
    dlv_dst_supervisor_name: {
      id: "dlv_dst_supervisor_name",
      name: "納入先部署担当者名",
      class: "Char_42",
    },
    code_no: { id: "code_no", name: "コードNo.", class: "Char_8" },
    item_name_1: { id: "item_name_1", name: "製品名", class: "Char_30" },
    item_name_2: { id: "item_name_2", name: "型式", class: "Char_20" },
    quantity: { id: "quantity", name: "数量", class: "Char_8" },
    price: { id: "price", name: "単価", class: "Char_8" },
    orre_aomount: { id: "orre_aomount", name: "金額", class: "Char_8" },
    mnfct_num: { id: "mnfct_num", name: "備考", class: "Char_20" },
    shipping_label_no: {
      id: "shipping_label_no",
      name: "送り状No.",
      class: "Char_15",
    },
    denno_shipment: {
      id: "denno_shipment",
      name: "出荷伝票番号",
      class: "Char_15",
    },
    denno_orre: { id: "denno_orre", name: "受注伝票番号", class: "Char_15" },
  };

  public headerKeys = [
    "orre_date",
    "desire_dlvr_day",
    "ans_dlvr_day",
    "sals_day",
    "order_num",
    "customer_name",
    "customer_supervisor_name",
    "dlv_dst_name",
    "dlv_dst_address",
    "dlv_dst_tel_number",
    "dlv_dst_supervisor_name",
    "code_no",
    "item_name_1",
    "item_name_2",
    "quantity",
    "price",
    "orre_aomount",
    "mnfct_num",
    "shipping_label_no",
    "denno_shipment",
    "denno_orre",
  ];

  public search = {
    date_type: "1",
    date_from: null,
    date_to: null,
    order_num: null,
    customer_name: "",
    customer_supervisor_name: "",
    dlv_dst_name: "",
    item_name_2: "",
    item_code: "",
    denno_shipment: "",
    denno_orre: "",
    status: [],
    page: null,
  };

  public statusList = [
    { id: "受付済", name: "受付済（変更可能）", color: "red" },
    { id: "準備中", name: "準備中", color: "blue" },
    { id: "出荷済", name: "出荷済", color: "green" },
    { id: "取消", name: "取消", color: "black" },
  ];

  public date_types = [
    { type: 1, type_name: "納入日（売上日）" },
    { type: 2, type_name: "ご注文日" },
    { type: 3, type_name: "確定出荷日" },
  ];

  public datePickerConfig = {
    dateFormat: DATE_PICKER_FORMAT,
  };

  public selected = [];
  public openList = [];
  public isSelectAll = false;

  get countShipment() {
    return _filter(this.orderHistories, (item) => item.status == "出荷済")
      .length;
  }

  @Watch("selected")
  public changeStatusOfSelectAllCheckbox() {
    this.isSelectAll = this.selected.length > 0 && this.selected.length == this.countShipment;
  }

  public groupShipmentByCustomer() {
    let selectedRow = this.orderHistories.filter((item) => {
      return item.status == "出荷済" && this.selected.includes(item.denno_shipment)
    });
    let selectedShipmentByCustomer = [];
    selectedRow.map((row) => {
      const customerCode = row.customer_code;
      selectedShipmentByCustomer[customerCode] = selectedShipmentByCustomer[customerCode] ?? {
        customer_name : row.customer_name,
        denno_shipments : []
      };
      selectedShipmentByCustomer[customerCode].denno_shipments.push(row.denno_shipment);
      return selectedShipmentByCustomer;
    }, {});

    return selectedShipmentByCustomer;
  }

  public mounted() {
    this.initalSearch(null);
    const headerKeys = !_isEmpty(store.state.Router.searchParameters)
      ? store.state.Router.searchParameters.orderHistoryHeaderKeys
      : {};
    if (!_isEmpty(headerKeys)) {
      this.headerKeys = Object.values(headerKeys);
    }
    // this.parserQuery();
    this.doSearch(this.search);
  }

  public parserQuery() {
    let { query } = this.$router.currentRoute;
    this.search = { ...this.search, ...query };
  }

  public initalSearch(parameters, clearFlag = false): void {
    const query = parameters || this.$router.currentRoute.query;
    if (query.status && !_isObject(query.status)) {
      query.status = [query.status];
    }
    console.log(query);
    this.search = {
      date_type: 1,
      date_from: !_isEmpty(store.state.Router.searchParameters) && !clearFlag && !_isEmpty(query)
        ? "" : moment().subtract(30, "days").format(DATE_TIME_FORMAT),
      date_to: "",
      order_num: null,
      customer_name: null,
      customer_supervisor_name: null,
      dlv_dst_name: null,
      item_name_2: null,
      item_code: null,
      denno_shipment: null,
      denno_orre: null,
      page: 1,
      status: ["受付済", "準備中", "出荷済", "取消"],
      ...query,
    };
  }

  public selectAll(value: boolean): void {
    this.selected = [];
    if (value) {
      this.orderHistories.map((item) => {
        if (item.status === "出荷済") {
          this.selected.push(item.denno_shipment);
        }
      });
    } else {
      this.selected = [];
    }
  }

  public getTokenRow(parentRow) {
    return (
      parentRow.denno_orre +
      (parentRow.denno_shipment ? parentRow.denno_shipment : "") +
      parentRow.status
    );
  }

  public resetSearch() {
    this.initalSearch({}, true);
    // this.changeState(true);
    this.doSearch(this.search);
  }

  public onSearch(): void {
    // this.changeState();
    this.search.page = 1;
    this.doSearch(this.search);
  }

  public async doSearch(query: any) {
    this.changeState();
    this.$nextTick(() => {
      (this.$refs.orderHistory as Element).scrollTop = 0;
    });

    store.dispatch("Router/setSearchParameters", {
      orderHistory: { ...query },
    });
    const result = await orderApi.getHistoryParentRecord(query);
    this.pagination = result.paginate;
    this.orderHistories = result.orderHistories;
    this.clearSelected();
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public clearSelected() {
    this.selected = [];
    this.openList = [];
  }

  public changeState(clear = false): void {
    let { name, params, query }:any = this.$router.currentRoute;

    query = { ...query, ...this.search };

    if (clear) {
      query = {};
    }

    // clear params null
    query = _pickBy(query, (item) => item);

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public openChild(row): void {
    const index = this.openList.indexOf(row);
    if (index > -1) {
      this.openList.splice(index, 1);
    } else {
      this.openList.push(row);
    }
  }

  public isOpen(row): boolean {
    return this.openList.includes(row);
  }

  public sortColumn() {
    store.dispatch("Router/setSearchParameters", {
      orderHistoryHeaderKeys: { ...this.headerKeys },
    });
  }

  public downloadPdf() {
    var selectedShipmentsByCustomer = this.groupShipmentByCustomer();
    console.log(selectedShipmentsByCustomer);

    for (const customerCode in selectedShipmentsByCustomer) {
      const selectedShipmentByCompany = selectedShipmentsByCustomer[customerCode];
      orderApi.downloadPdf({ shipments: selectedShipmentByCompany.denno_shipments }).then(
        (response) => {
          if (response.status == "200") {
            console.log(response);
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              this.$t(`download_files.order_history`, {
                filename: selectedShipmentByCompany.customer_name + '_' + moment().format(DATETIME_FORMAT_PDF_FILE_NAME),
              }).toString()
            );

            // eslint-disable-next-line unicorn/prefer-dom-node-append
            document.body.appendChild(fileLink);
            fileLink.click();

            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            document.body.removeChild(fileLink);

            qNotify.success({
              text: this.$t("order_history_page.messsage.print_pdf_success"),
            });
          }
        }
      );
    }
  }

  public isMoneyColumn(header) {
    if (!header) return false;

    const momeyColumn = ["price", "orre_aomount"];
    return momeyColumn.includes(header);
  }

  public onDragEnd() {
    const className = 'grabbing';
    const html = document.querySelectorAll('html').item(0);
    if (html && new RegExp(className).test(html.className) === true) {
      // Remove className with the added space (from setClassToHTMLElement)
      html.className = html.className.replace(
        new RegExp(' ' + className),
        ''
      );
      // Remove className without added space (just in case)
      html.className = html.className.replace(new RegExp(className), '');
    }
  }

  public onStart() {
    const className = 'grabbing';
    const html = document.querySelectorAll('html').item(0);
    if (html && new RegExp(className).test(html.className) === false) {
      html.className += ' ' + className; // use a space in case there are other classNames
    }
  }

}
